/**
 * 判断宿主环境
 */
import { parseQueryString, getCookie } from 'utils/common'

const ua = navigator.userAgent.toLowerCase()
const vvcPn = getCookie('vvc_pn')
const vvcOsVersion = getCookie('vvc_os_version') // 模拟：document.cookie = 'vvc_os_version=14.0'
const isOS4 = vvcOsVersion && vvcOsVersion * 1 >= 14 // OS系统版本是否为Origin OS4.0
// 安卓环境
const isAndroid = /android/i.test(ua)
const android = ua.match(/(Android);?[\s/]+([\d.]+)?/i)
const androidLevel = android && android[2] ? android[2].substr(0, 3) * 1 : undefined
const isLowAndroid = androidLevel && androidLevel < 6
// ios环境
const isIOS = /ipad|iphone|ipod/i.test(ua) && !window.MSStream
// 微信环境
const isWx = /micromessenger/i.test(ua)
// qq浏览器
const isQQBrowser = /MQQBrowser/i.test(ua)
// qq环境
const isQQ = /qq/i.test(ua) && !isQQBrowser
// 支付宝环境
const isAlipay = /AlipayClient|AliApp\(AP/i.test(ua)
// vivo官网app
const isVivoApp = /VivoSpace/i.test(ua)
// 安卓vivo官网app
const isAndroidVivoApp = isVivoApp && isAndroid
// vivo官网iOS app
const isIOSVivoApp = isVivoApp && isIOS
// vivo浏览器
const isVivoBrowser = /VivoBrowser/i.test(ua)
// uc浏览器
const isUCBrowser = /UCBrowser/i.test(ua)
// vivo pad
const isVivoPad = /tablet/i.test(ua)
// vivo APP pad
const isPadVivoApp = isVivoApp && isVivoPad
// vivo app 折叠屏
const isFoldableApp = /foldable/i.test(ua) && isVivoApp
// jovi物联/智慧生活
const isVHome = /vHome/i.test(ua)
// 农行app
const isBankabc = /Bankabc/i.test(ua)
// vivo官网app版本
const appVer = parseQueryString(ua).app_ver
const appVersion = appVer && appVer.split(' ')[0]
// 官网1.0.10版本以下图片上传功能屏蔽
const isOpenUpload = !(isVivoApp && appVersion && appVersion < 110)
// 新版商详页改版后，官网App默认不显示titlebar TODO: 飘落的枫叶，需要改成对应的官网App版本号
const isDefaultHideTitle = isVivoApp && appVersion && appVersion >= 4810
// iPhoneX
const iPhoneX = isIOS && window.screen.height == 812 && window.screen.width == 375
// v消息环境, IOS上面没有vChat标识
const isvChat = /vChat/i.test(ua) || window.wpt
// 是否是游戏中心
const isGameCenter = vvcPn === 'com.vivo.game'
// 是否是应用商店
const isAppStore = vvcPn === 'com.bbk.appstore'
// 是否是vivo钱包
const isWallet = vvcPn === 'com.vivo.wallet'
// 是否是i音乐
const isiMusic = vvcPn === 'com.android.bbkmusic'
// 是否是i主题
const isiTheme = vvcPn === 'com.bbk.theme'
// 是否是vivo视频
const isVivoVideo = vvcPn === 'com.android.VideoPlayer'
// 是否是智慧场景
const isJovi = vvcPn === 'com.vivo.assistant'
// 是否是vivo健康,enterprise为企业包，内部测试之用，附带一些测试环境和方法，health为正式包
const isVivoHealth = vvcPn === 'com.vivo.health' || vvcPn === 'com.vivo.health-enterprise' || /VivoHealth/i.test(ua)
// 是否是vivo系app，不包含vivo浏览器
const isVivoRelatedApp =
  isVivoApp ||
  isVHome ||
  isvChat ||
  isGameCenter ||
  isAppStore ||
  isWallet ||
  isiMusic ||
  isiTheme ||
  isVivoVideo ||
  // isJovi ||
  isVivoHealth ||
  isFoldableApp

// vivo手机
// const isVivoPhone = /vivo/i.test(ua) && !isIOSVivoApp

// vivo手机
const isVivoPhone = getCookie('isvivophone') == 1 // 1: vivo手机（包括iqoo), 2：其他安卓品牌手机，苹果手机app没有此cookie

// 微信小程序
const isWeChatApp = () => {
  if (ua.indexOf('miniprogram') > -1) {
    return new Promise(resolve => {
      resolve(true)
    })
  } else {
    return new Promise(resolve => {
      if (ua.indexOf('micromessenger') != -1) {
        // eslint-disable-next-line
        let _wx = parent?.wx || wx // 可能在微信H5中嵌套iframe使用，需要调parent的wx方法，直接调wx.miniProgram.getEnv 方法阻塞
        // ios企业微信中有该方法，android中无getEnv方法，会报错
        if (_wx.miniProgram && _wx.miniProgram.getEnv) {
          _wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              // 3.4版本添加
              resolve(true)
            } else {
              resolve(false)
            }
          })
        } else {
          resolve(false)
        }
      } else {
        resolve(false)
      }
    })
  }
}

const checkWeChat = async () => {
  const res = await isWeChatApp()
  if (res) return true
  else return false
}

const noOpenUplaodInMini = checkWeChat() && androidLevel > 5.1

// 360度黑名单：安卓5版本以下、QQ浏览器、农行、jovi物联、运动健康、微信、QQ、支付宝（正式对接过的途径）
const blackList3D =
  (isAndroid && androidLevel < 6) || isQQBrowser || isBankabc || isVHome || isVivoHealth || isWx || isQQ || isAlipay

const isWhite3D = !blackList3D

export default {
  ua,
  isAndroid,
  androidLevel,
  isLowAndroid,
  isVivoPhone,
  isIOS,
  iPhoneX,
  isWx,
  isQQ,
  isQQBrowser,
  isAlipay,
  isVivoApp,
  isAndroidVivoApp,
  isIOSVivoApp,
  isVivoBrowser,
  isUCBrowser,
  appVersion,
  clientModel: parseQueryString(ua).model,
  isVHome,
  isBankabc,
  isOpenUpload,
  isDefaultHideTitle,
  isWeChatApp,
  isvChat,
  isGameCenter,
  isAppStore,
  isWallet,
  isiMusic,
  isiTheme,
  isVivoVideo,
  isJovi,
  isVivoHealth,
  isVivoRelatedApp,
  checkWeChat,
  noOpenUplaodInMini,
  isWhite3D,
  isVivoPad,
  isPadVivoApp,
  isFoldableApp,
  isOS4
}
